import React, {useState, useEffect} from 'react';
import { Modal, Paper } from '@mui/material';
import EditOrganizationLayout from '../layouts/EditOrganizationLayout';
import getOrganizations from "../../../data/organization/getOrganizations";
import {Organization} from "../../../classes/Organization";

function UpdateOrganizationModal(props: {
    isOpen: boolean,
    selectedOrganizationObject: Organization,
    onClose: Function,
    onSubmit: Function,
    onNetworkError: Function
}) {
    const [organizationList, setOrganizationList] = useState<Organization[] | undefined>(undefined)

    useEffect(() => {
        getOrganizations()
            .then((result) => setOrganizationList(result))
            .catch((err) => {
                console.error(err)
                props.onNetworkError()
            })
    }, [])

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <EditOrganizationLayout
                    title="Update Organization"
                    initInfo={props.selectedOrganizationObject}
                    organizationList={organizationList}
                    onCancel={() => props.onClose()}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default UpdateOrganizationModal;